export class dtoCurrentUser {
	id: number;
	roleId: number;
	sectorId: number;
	email: string;
	name: string;
	accountApproval: boolean;
	role: number;
	token?: string;
}